<template>
    <div class="progress-bar-container" :class="progressContainerClasses">
        <div class="progress-bar-inner" :class="progressClasses" :style="innerStyles"></div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',

    props: {
        max: {
            type: Number,
            required: false,
            default: 100
        },

        current: {
            type: Number,
            required: false,
            default: 100,
        },

        progressContainerClasses: {
            type: Object,
            required: false,
            default: () => ({
                'bg-white': true,
            }),
        },

        progressClasses: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

    computed: {
        innerStyles() {
            return {
                width: `${Math.min(this.current / this.max, 1) * 100}%`,
            }
        }
    }
}
</script>

<style>
.progress-bar-container {
    width: 100%;
    height: 5px;
    border-radius: 5px;
}

.progress-bar-inner {
    background: #548870;
    height: 100%;
    border-radius: 5px;
}
</style>
